import {Axios} from '../axios/axios.js'

export const getInboxList = (e) => {
  return Axios({
    url:"/invite/get_invite_list",
    method:'put',
    data:e
  })
}
//获取各省汇率 public_data/get_rate
export const getRate = (e) => {
  return Axios({
    url:"public_data/get_rate",
    method:'put',
    data:e
  })
}
//同意邀请 /invite/agree_invite
export const agreeInvite = (e) => {
  return Axios({
    url:"invite/agree_invite",
    method:'put',
    data:e
  })
}
//拒绝 /invite/reject_invite
export const rejectInvite = (e) => {
  return Axios({
    url:"invite/reject_invite",
    method:'put',
    data:e
  })
}
